<template src="./CreateDocumentPlan.html"></template>

<script>
import {
  createDocumentPlanTemplate,
  updateDocumentPlan,
} from "../../../services/document";
import DocumentList from "../../../components/Forms/DocumentList/DocumentList";

export default {
  name: "CreateDocumentPlan",
  components: {
    DocumentList,
  },
  data() {
    return {
      plan: {
        name: "",
        description: "",
      },
      newDocument: {
        name: "",
        plannedDate: new Date().toISOString().substr(0, 10),
      },
      documents: [],
      showDocumentForm: false,
      menu: false,
      update: false,
    };
  },
  created() {
    if (this.$route.params.updatePlan) {
      this.isUpdatePlan();
      this.update = true;
    }
  },
  methods: {
    isUpdatePlan() {
      if (this.$route.params.updatePlan) {
        this.plan = { ...this.$route.params.updatePlan };
        this.documents = this.plan.documents || [];
      }
    },
    addDocument() {
      if (!this.newDocument.name) {
        this.$swal({
          text: "El nombre del documento es obligatorio",
          buttons: false,
          icon: "warning",
          timer: 3000,
        });
        return;
      }
      this.documents.push({
        ...this.newDocument,
      });
      this.newDocument.name = "";
      this.newDocument.plannedDate = new Date().toISOString().substr(0, 10);
      this.showDocumentForm = false;
    },
    showFormDocument() {
      this.showDocumentForm = true;
    },
    async savePlan() {
      try {
        if (this.plan.name && this.documents.length > 0) {
          const planData = {
            ...this.plan,
            documents: this.documents.map((document) => ({
              ...document,
              plannedDate: new Date(document.plannedDate),
            })),
          };
          await createDocumentPlanTemplate(planData);
          this.$swal({
            text: "Plantilla creada correctamente.",
            buttons: false,
            icon: "success",
            timer: 3000,
          });
          this.$router.push("/planes-documentales");
        } else if (!this.plan.name) {
          this.$swal({
            text: "El nombre del plan y la descripción son obligatorios",
            buttons: false,
            icon: "warning",
            timer: 3000,
          });
        } else {
          this.$swal({
            text: "Debe agregar un documento",
            buttons: false,
            icon: "warning",
            timer: 3000,
          });
        }
      } catch (error) {
        console.log("save plan:", error);
      }
    },
    async changePlan() {
      if (this.plan.name && this.documents.length > 0) {
        const organizedDocuments = this.documents.map((document) => {
          return {
            name: document.name,
            plannedDate: document.plannedDate,
            id: document.id || undefined,
          };
        });
        const planData = {
          id: this.plan.id,
          name: this.plan.name,
          description: this.plan.description,
          documents: organizedDocuments,
        };
        await updateDocumentPlan(planData);
        this.$swal({
          text: "Plan actualizado correctamente.",
          buttons: false,
          icon: "success",
          timer: 3000,
        });
        this.$router.push("/planes-documentales");
      } else if (!this.plan.name) {
        this.$swal({
          text: "El nombre del plan y la descripción son obligatorios",
          buttons: false,
          icon: "warning",
          timer: 3000,
        });
      } else {
        this.$swal({
          text: "Debe agregar un documento",
          buttons: false,
          icon: "warning",
          timer: 3000,
        });
      }
    },
    removeDocument(document) {
      this.documents = this.documents.filter((t) => t !== document);
    },
    cancelDocument() {
      this.newDocument.name = "";
      this.newDocument.plannedDate = new Date().toISOString().substr(0, 10);
      this.showDocumentForm = false;
    },
  },
};
</script>
